import { Button } from '@consta/uikit/Button'
import classes from './ProjectsContent.module.scss'
import { Text } from '@consta/uikit/Text'
import { IconAdd } from '@consta/icons/IconAdd'
import { Card } from '@consta/uikit/Card'
import { TextField } from '@consta/uikit/TextField'
import { Combobox } from '@consta/uikit/Combobox'
import { DatePicker } from '@consta/uikit/DatePicker'
import { useState, useRef, useMemo, useEffect } from 'react'
import { Checkbox } from '@consta/uikit/Checkbox'
import { ContextMenu } from '@consta/uikit/ContextMenu'
import { NavLink, useNavigate } from 'react-router-dom'
import { IconKebab } from '@consta/icons/IconKebab'
import { Table, TableColumn } from '@consta/uikit/Table'
import { Pagination } from '@consta/uikit/Pagination'
import { Modal } from '@consta/uikit/Modal'
import { useCopyProjectMutation, useLazyGetProjectQuery, usePostProjectMutation, useReturnProjectMutation } from '../../../services/projectService'
import { useLazyGetCompanyQuery } from '../../../services/companyService'
import { useLazyGetFieldQuery } from '../../../services/fieldService'
import { PostProjectsRequest, Project } from '../../../services/types/TProjectServices'
import { Company } from '../../../services/types/TCompanyServices'
import { Field } from '../../../services/types/TFieldServices'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import { useLazyGetByProjectQuery } from '../../../services/reportService'

type CustomerType = {
    id: string;
    label: string
}

type FieldType = {
    id: string;
    label: string
}

type Row = {
    id: any;
    number: string;
    name: any;
    customer: string;
    field: string;
    stage: string;
    start: string;
    end: string;
    is_completed: any;
    action?: any
};

type CompanyItem = {
    id: string;
    label: string;
}

type ContextMenuItem = {
    id: number;
    label: string;
    path: string;
}

// Компонент для ячейки с действиями
const ProjectActionCell = ({ project, onSuccess }: { project: Project | any; onSuccess?: () => void; }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
    const [isReturnModalOpen, setIsReturnModalOpen] = useState(false);
    const ref = useRef<HTMLButtonElement | any>(null);
    const [getByProject, {data: reportByProject}] = useLazyGetByProjectQuery()
    const [copyProject, { isLoading: isCopying }] = useCopyProjectMutation()
    const [returnProject, { isLoading: isReturning }] = useReturnProjectMutation()
    
    // Состояния для формы копирования
    const [copyProjectName, setCopyProjectName] = useState('')
    const [copyProjectNumber, setCopyProjectNumber] = useState('')
    const [copyProjectDescription, setCopyProjectDescription] = useState('')
    
    // useEffect(() => {
    //     getByProject({project_uuid: project?.uuid})
    // },[project])

    // Заполняем форму данными из исходного проекта при открытии
    useEffect(() => {
        if (isCopyModalOpen && project) {
            setCopyProjectName(`${project.name} (копия)`);
            setCopyProjectNumber(project.number);
            setCopyProjectDescription(project.description || '');
        }
    }, [isCopyModalOpen, project]);

    // Формируем пункты меню в зависимости от статуса проекта
    const contextMenuItems = useMemo(() => {
        const items = [
            { id: 1, label: "Данные о проекте", path: `/project/${project.uuid}` },
            { id: 2, label: "Результаты и отчетные материалы", path: `/project/${project.uuid}/results` },
            { id: 3, label: "Хроматограмма", path: `/project/${project.uuid}/chromatogram` },
            { id: 4, label: "Скважины", path: `/project/${project.uuid}/wells` },
            //@ts-ignore
            { id: 5, label: "Мониторинг", path: project?.is_completed == true ? `/report/${reportByProject?.uuid}/` : project?.current_stage > 1 ? `/project/${project.uuid}/monitoring/${project.current_stage}` :  `/project/${project.uuid}/monitoring` },
        ];

        // Добавляем разделитель (визуально) и пункт копирования
        //@ts-ignore
        items.push({ id: 6, label: "Копировать проект", action: 'copy' });
        
        // Если проект завершен, добавляем пункт возврата в работу
        if (project?.is_completed) {
            //@ts-ignore
            items.push({ id: 7, label: "Возврат проекта в работу", action: 'return' });
        }
        
        return items;
    }, [project, reportByProject]);

    const handleContextMenuOpen = (event: React.MouseEvent) => {
        event.stopPropagation();
        setIsOpen(true);
    };

    const handleContextMenuItemClick = (item: ContextMenuItem & { action?: string }) => {
        setIsOpen(false);
        
        if (item.action === 'copy') {
            setIsCopyModalOpen(true);
        } else if (item.action === 'return') {
            setIsReturnModalOpen(true);
        } else {
            navigate(item.path);
        }
    };

    const handleCopyProject = async () => {
        if (!copyProjectName || !copyProjectNumber) {
            return;
        }

        try {
            await copyProject({
                uuid: project.uuid,
                new_name: copyProjectName,
                number: copyProjectNumber,
                description: copyProjectDescription
            }).unwrap();
            
            setIsCopyModalOpen(false);
            // Сбрасываем форму
            setCopyProjectName('');
            setCopyProjectNumber('');
            setCopyProjectDescription('');
            
            // Вызываем обновление данных
            if (onSuccess) {
                onSuccess();
            }
            
            // Показываем уведомление об успехе
            // alert('Проект успешно скопирован');
        } catch (error) {
            console.error('Ошибка копирования проекта:', error);
            // alert('Ошибка при копировании проекта');
        }
    };

    const handleReturnProject = async () => {
        try {
            await returnProject({
                uuid: project.uuid,
                is_completed: false
            }).unwrap();
            
            setIsReturnModalOpen(false);
            
            // Вызываем обновление данных
            if (onSuccess) {
                onSuccess();
            }
            
            // Показываем уведомление об успехе
            // alert('Проект успешно возвращен в работу');
        } catch (error) {
            console.error('Ошибка возврата проекта в работу:', error);
            // alert('Ошибка при возврате проекта в работу');
        }
    };

    return (
        <div className={classes.actionCell}>
            <Button
                size='s'
                iconLeft={IconKebab}
                view='clear'
                onClick={handleContextMenuOpen}
                ref={ref}
            />
            <ContextMenu
                isOpen={isOpen}
                items={contextMenuItems}
                getItemLabel={(item) => item.label}
                direction="downStartRight"
                size='s'
                onClickOutside={() => setIsOpen(false)}
                getItemOnClick={(item) => () => handleContextMenuItemClick(item)}
                anchorRef={ref}
            />
            
            <Modal
                isOpen={isCopyModalOpen}
                hasOverlay
                onClickOutside={() => setIsCopyModalOpen(false)}
                onEsc={() => setIsCopyModalOpen(false)}
            >
                <Card className={classes.modalCard} verticalSpace="m" horizontalSpace="m" style={{padding: '20px', minWidth: '600px'}}>
                    <Text size="xl" weight="bold" className={classes.modalTitle}>
                        Копировать проект
                    </Text>

                    <div className={classes.form} style={{display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '20px'}}>
                        <TextField
                            label="Название проекта"
                            value={copyProjectName}
                            onChange={(value) => setCopyProjectName(value || '')}
                            className={classes.formField}
                            required
                        />

                        {/* <TextField
                            label="Номер проекта"
                            value={copyProjectNumber}
                            onChange={(value) => setCopyProjectNumber(value || '')}
                            className={classes.formField}
                            required
                        /> */}

                        <TextField
                            label="Описание"
                            value={copyProjectDescription}
                            onChange={(value) => setCopyProjectDescription(value || '')}
                            className={classes.formField}
                            rows={4}
                            type='textarea'
                        />

                        <div className={classes.modalActions} style={{display: 'flex', flexDirection: 'row', gap: '20px', justifyContent: 'end', alignItems: 'center', marginTop: '20px'}}>
                            <Button
                                label="Отмена"
                                view="clear"
                                onClick={() => setIsCopyModalOpen(false)}
                                className={classes.cancelButton}
                            />
                            <Button
                                label={isCopying ? "Копирование..." : "Копировать проект"}
                                onClick={handleCopyProject}
                                disabled={isCopying || !copyProjectName}
                                className={classes.createButton}
                            />
                        </div>
                    </div>
                </Card>
            </Modal>

            <Modal
                isOpen={isReturnModalOpen}
                hasOverlay
                onClickOutside={() => setIsReturnModalOpen(false)}
                onEsc={() => setIsReturnModalOpen(false)}
                style={{padding: '24px'}}
            >
                    <div style={{display: 'flex', flexDirection: 'column', gap: '24px', height: '100%'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <Text size="l" weight="bold">
                                Возврат проекта в работу
                            </Text>
                        </div>

                        <Text size="m" className={classes.modalDescription}>
                            Вы уверены, что хотите вернуть проект <strong>«{project?.name}»</strong> в работу?
                        </Text>

                        <div className={classes.modalActions} style={{
                            display: 'flex', 
                            flexDirection: 'row', 
                            gap: '12px', 
                            justifyContent: 'flex-end', 
                            alignItems: 'center',
                            marginTop: '20px'
                        }}>
                            <Button
                                label="Отмена"
                                view="clear"
                                onClick={() => setIsReturnModalOpen(false)}
                                className={classes.cancelButton}
                            />
                            <Button
                                label={isReturning ? "Возврат..." : "Вернуть в работу"}
                                onClick={handleReturnProject}
                                disabled={isReturning}
                                className={classes.returnButton}
                            />
                        </div>
                    </div>
            </Modal>
        </div>
    );
};

const ProjectsContent = () => {
    const navigate = useNavigate();
    
    const [customer, setCustomer] = useState<CustomerType | null>(null)
    const [field, setField] = useState<FieldType | null>(null)
    const [valueStart, setValueStart] = useState<Date | any | null>(null)
    const [valueEnd, setValueEnd] = useState<Date | any | null>(null)
    const [isInProgress, setIsInProgress] = useState<boolean>(false)
    const [searchValue, setSearchValue] = useState<string | any>('')
    const [debouncedSearchValue, setDebouncedSearchValue] = useState<string | any>('')
    const [page, setPage] = useState<any>(1)
    const [isModalOpen, setIsModalOpen] = useState<any>(false)

    const dateStart= new Date(valueStart);

    const yearStart = dateStart.getFullYear();
    const monthStart = (dateStart.getMonth() + 1).toString().padStart(2, '0');
    const dayStart = dateStart.getDate().toString().padStart(2, '0');

    const formattedDateStart = `${yearStart}-${monthStart}-${dayStart}`;
    const dateEnd= new Date(valueEnd);

    const yearEnd = dateEnd.getFullYear();
    const monthEnd = (dateEnd.getMonth() + 1).toString().padStart(2, '0');
    const dayEnd = dateEnd.getDate().toString().padStart(2, '0');

    const formattedDateEnd = `${yearEnd}-${monthEnd}-${dayEnd}`;

    // States for new project form
    const [projectName, setProjectName] = useState('')
    const [projectDescription, setProjectDescription] = useState('')
    const [projectNumber, setProjectNumber] = useState('')
    const [projectStartDate, setProjectStartDate] = useState<Date | null>(null)
    const [projectEndDate, setProjectEndDate] = useState<Date | null>(null)
    const [selectedCompany, setSelectedCompany] = useState<CompanyItem | null>(null)

    const [getProjects, { data, isError, isLoading }] = useLazyGetProjectQuery()
    const [getCompanies, { data: companiesData }] = useLazyGetCompanyQuery()
    const [getFields, { data: fieldsData }] = useLazyGetFieldQuery()
    const [postProject, { isLoading: isCreating }] = usePostProjectMutation()

    const userInfo = useSelector((state: RootState) => state.auth.userInfo);

    const refreshProjects = () => {
        getProjects(requestParams);
    };

    // Простой debounce для поиска
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchValue(searchValue)
            setPage(1)
        }, 500)

        return () => clearTimeout(timer)
    }, [searchValue])

    // Загрузка данных для фильтров
    useEffect(() => {
        loadCompaniesForFilter();
        loadFieldsForFilter();
    }, []);

    const handleCustomerChange = (value: CustomerType | null) => {
        setCustomer(value || customerItems[0]);
        setPage(1); // 👈 Сбрасываем страницу
    };

    const handleFieldChange = (value: FieldType | null) => {
        setField(value || fieldItems[0]);
        setPage(1); // 👈 Сбрасываем страницу
    };

    const handleStartDateChange = (value: Date | null) => {
        setValueStart(value);
        setPage(1); // 👈 Сбрасываем страницу
    };

    const handleEndDateChange = (value: Date | null) => {
        setValueEnd(value);
        setPage(1); // 👈 Сбрасываем страницу
    };

    const handleInProgressChange = () => {
        setIsInProgress(!isInProgress);
        setPage(1); // 👈 Сбрасываем страницу
    };

    const loadCompaniesForFilter = async () => {
        try {
            const response = await getCompanies({ limit: 9999, offset: 0, ordering: 'name' }).unwrap();
            
            const customerItems: CustomerType[] = [
                { id: 'all', label: 'Все заказчики' },
                ...response.results.map((company: Company) => ({
                    id: company.uuid,
                    label: company.name
                }))
            ];
            
            setCustomer(customerItems[0]);
        } catch (error) {
            console.error('Ошибка загрузки компаний для фильтра:', error);
        }
    };

    const loadFieldsForFilter = async () => {
        try {
            const response = await getFields({ limit: 9999, offset: 0, ordering: 'name' }).unwrap();
            
            const fieldItems: FieldType[] = [
                { id: 'all', label: 'Все месторождения' },
                ...response.results.map((field: Field) => ({
                    id: field.uuid,
                    label: field.name
                }))
            ];
            
            setField(fieldItems[0]);
        } catch (error) {
            console.error('Ошибка загрузки месторождений для фильтра:', error);
        }
    };

    // Подготовка параметров запроса с фильтрами
    const requestParams = useMemo(() => {
        const params: any = {
            limit: 10,
            offset: (page - 1) * 10,
            ordering: 'created_at',
        };

        // Фильтрация по компании (для пользователей с доступом)
        if (userInfo?.role?.access_level == 0) {
            params.companies = userInfo?.company?.uuid;
        }

        // Поиск по названию и номеру - просто передаем значение
        if (debouncedSearchValue) {
            params.search = debouncedSearchValue;
        }

        // Фильтрация по заказчику
        if (customer && customer.id !== 'all') {
            params.companies = customer.id;
        }

        // Фильтрация по месторождению
        if (field && field.id !== 'all') {
            params.fields = field.id;
        }

        // Фильтрация по дате начала
        if (valueStart) {
            params.start_date = formattedDateStart;
        }

        // Фильтрация по дате окончания
        if (valueEnd) {
            params.end_date = formattedDateEnd;
        }

        // Фильтрация по статусу "В работе"
        if (isInProgress) {
            params.in_work = true;
        }

        return params;
    }, [page, debouncedSearchValue, customer, field, valueStart, valueEnd, isInProgress, userInfo]);

    // Запрос проектов при изменении параметров
    useEffect(() => {
        getProjects(requestParams)
    }, [requestParams, getProjects])

    // Load companies when modal opens
    useEffect(() => {
        if (isModalOpen) {
            getCompanies({ limit: 9999, offset: 0, ordering: 'name' })
        }
    }, [isModalOpen, getCompanies])

    const formatDate = (dateString: string) => {
        if (!dateString) return 'Не указана';
        try {
            return new Date(dateString).toLocaleDateString('ru-RU')
        } catch {
            return 'Неверная дата';
        }
    }

    // Prepare companies for Combobox
    const companyItems: CompanyItem[] = useMemo(() => {
        if (!companiesData?.results) return []

        return companiesData.results.map((company: Company) => ({
            id: company.uuid,
            label: company.name
        }))
    }, [companiesData])

    // Prepare fields for Combobox filter
    const fieldItems: FieldType[] = useMemo(() => {
        if (!fieldsData?.results) return [
            { id: 'all', label: 'Все месторождения' }
        ]

        return [
            { id: 'all', label: 'Все месторождения' },
            ...fieldsData.results.map((field: Field) => ({
                id: field.uuid,
                label: field.name
            }))
        ]
    }, [fieldsData])

    // Prepare customers for Combobox filter
    const customerItems: CustomerType[] = useMemo(() => {
        if (!companiesData?.results) return [
            { id: 'all', label: 'Все заказчики' }
        ]

        return [
            { id: 'all', label: 'Все заказчики' },
            ...companiesData.results.map((company: Company) => ({
                id: company.uuid,
                label: company.name
            }))
        ]
    }, [companiesData])

    const handleCreateProject = async () => {
        if (!projectName || !selectedCompany || !projectStartDate) {
            return
        }

        const projectData: PostProjectsRequest = {
            name: projectName,
            description: projectDescription,
            number: projectNumber,
            start_date: projectStartDate ? projectStartDate.toISOString().split('T')[0] : '',
            end_date: projectEndDate ? projectEndDate.toISOString().split('T')[0] : '',
            is_completed: false,
            current_stage: 1,
            company: selectedCompany.id
        }

        try {
            await postProject(projectData).unwrap();
            setIsModalOpen(false);
            // Сбрасываем форму
            setProjectName('');
            setProjectDescription('');
            setProjectNumber('');
            setProjectStartDate(null);
            setProjectEndDate(null);
            setSelectedCompany(null);

            getProjects(requestParams);
        } catch (error) {
            console.error('Ошибка создания проекта:', error);
        }
    }

    const projects = data?.results || []
    const totalCount = data?.count || 0

    const rows: Row[] = useMemo(() => {
        if (!projects || projects.length === 0) {
            return [];
        }

        return projects.map((project: Project | any) => ({
            id: project.id,
            number: ` ${project.number || 'Не указан'}`,
            name: (
                <NavLink
                    to={`/project/${project.uuid}`}
                    className={classes.projectLink}
                >
                    {project.name || `Проект №${project.number}`}
                </NavLink>
            ),
            customer: ` ${project.company_name || 'Не указан'}`,
            field: ` ${project.fields?.join(', ') || 'Не указано'}`,
            stage: ` ${project.current_stage || 'Не указан'}`,
            start: formatDate(project.start_date),
            end: formatDate(project.end_date),
            is_completed: `${project?.is_completed == true ? 'Завершен' : 'В работе'}` ,
            action: <ProjectActionCell project={project} onSuccess={refreshProjects} /> // Добавлен onSuccess
        }))
    }, [projects, refreshProjects]); 

    //@ts-ignore
    const columns: TableColumn<Row>[] = [
        {
            title: 'Название',
            accessor: 'name',
            width: 300
        },
        {
            title: '№ проекта',
            accessor: 'number',

        },
        {
            title: 'Заказчик',
            accessor: 'customer',
        },
        {
            title: 'Месторождение',
            accessor: 'field',
        },
        {
            title: 'Этап',
            accessor: 'stage',
        },
        {
            title: 'Дата начала',
            accessor: 'start',
        },
        {
            title: 'Дата окончания',
            accessor: 'end',
        },
        {
            title: 'Статус',
            accessor: 'is_completed',
        },
        {
            title: '',
            accessor: 'action',
            align: 'right',
        },
    ];

    const totalPages = Math.ceil(totalCount / requestParams.limit)

    const handlePageChange = (newPage: number) => {
        setPage(newPage)
    }

    // Проверка наличия активных фильтров
    const hasActiveFilters = useMemo(() => {
        return debouncedSearchValue !== '' ||
               (customer && customer.id !== 'all') ||
               (field && field.id !== 'all') ||
               valueStart !== null ||
               valueEnd !== null ||
               isInProgress;
    }, [debouncedSearchValue, customer, field, valueStart, valueEnd, isInProgress]);

    // Очистка всех фильтров
    const clearAllFilters = () => {
        setSearchValue('');
        setDebouncedSearchValue('');
        setCustomer(customerItems.find(c => c.id === 'all') || null);
        setField(fieldItems.find(f => f.id === 'all') || null);
        setValueStart(null);
        setValueEnd(null);
        setIsInProgress(false);
        setPage(1);
    };

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <div className={classes.text}>
                    <Text size='xl' weight='bold'>Проекты</Text>
                    <Text size='s' view="secondary">
                        Управляйте своими проектами и просматривайте их статус
                        {!isLoading && data && ` • Найдено: ${totalCount} проектов`}
                        {hasActiveFilters && ' (отфильтровано)'}
                    </Text>
                </div>
                {userInfo?.role?.access_level == 3 &&
                    <Button
                        size='s'
                        iconLeft={IconAdd}
                        label='Новый проект'
                        onClick={() => setIsModalOpen(true)}
                    />
                }
            </div>

            <div className={classes.filter}>
                <Card className={classes.filterCard}>
                    <TextField
                        placeholder='Поиск...'
                        size='xs'
                        value={searchValue}
                        onChange={setSearchValue}
                        className={classes.searchField}
                        withClearButton
                    />
                    {userInfo?.role?.access_level !== 0 &&
                    <Combobox
                        items={customerItems}
                        value={customer}
                        getItemLabel={item => item.label}
                        getItemKey={item => item.id}
                        onChange={handleCustomerChange}
                        size='xs'
                        className={classes.comboboxField}
                        placeholder='Выберите заказчика'
                    />
                    }
                    <Combobox
                        items={fieldItems}
                        value={field}
                        getItemLabel={item => item.label}
                        getItemKey={item => item.id}
                        onChange={handleFieldChange}
                        size='xs'
                        className={classes.comboboxField}
                        placeholder='Выберите месторождение'
                    />
                    <DatePicker
                        value={valueStart}
                        onChange={handleStartDateChange}
                        size='xs'
                        className={classes.dateField}
                        placeholder='Дата начала'
                    />
                    <DatePicker
                        value={valueEnd}
                        onChange={handleEndDateChange}
                        size='xs'
                        className={classes.dateField}
                        placeholder='Дата окончания'
                    />
                    <Checkbox 
                        label='В работе' 
                        size='xs' 
                        checked={isInProgress} 
                        onChange={handleInProgressChange}
                    />
                    
                    {hasActiveFilters && (
                        <Button
                            size='xs'
                            view='clear'
                            label='Очистить фильтры'
                            onClick={clearAllFilters}
                        />
                    )}
                </Card>
            </div>

            <div className={classes.content}>
                {isLoading && (
                    <div className={classes.loadingContainer}>
                        <Text>Загрузка проектов...</Text>
                    </div>
                )}

                {isError && (
                    <div className={classes.errorContainer}>
                        <Text view="alert">
                            Ошибка при загрузке проектов
                        </Text>
                        <Button
                            label="Повторить попытку"
                            onClick={() => getProjects(requestParams)}
                            className={classes.retryButton}
                        />
                    </div>
                )}

                {!isLoading && !isError && projects.length === 0 && (
                    <div className={classes.emptyContainer}>
                        <Text>
                            {hasActiveFilters 
                                ? 'Проекты по заданным фильтрам не найдены' 
                                : 'Нет проектов для отображения'
                            }
                        </Text>
                        {hasActiveFilters && (
                            <Button
                                label="Очистить фильтры"
                                onClick={clearAllFilters}
                                size="s"
                            />
                        )}
                    </div>
                )}

                {!isLoading && !isError && projects.length > 0 && (
                    <div className={classes.tableCard}>
                        <div className={classes.tableWrapper}>
                            <Table
                                rows={rows}
                                columns={columns}
                                verticalAlign="top"
                                stickyHeader
                                size='m'
                                borderBetweenRows
                                borderBetweenColumns
                                className={classes.projectsTable}
                                
                            />
                        </div>
                        {totalPages > 1 && (
                            <div className={classes.paginationSection}>
                                <Pagination
                                    items={totalPages}
                                    value={page}
                                    onChange={handlePageChange}
                                    showFirstPage
                                    showLastPage
                                    visibleCount={7}
                                    size='s'
                                    className={classes.pagination}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Modal for creating new project */}
            <Modal
                isOpen={isModalOpen}
                hasOverlay
                onClickOutside={() => setIsModalOpen(false)}
                onEsc={() => setIsModalOpen(false)}
            >
                <Card className={classes.modalCard} verticalSpace="m" horizontalSpace="m" style={{padding: '20px', minWidth: '600px'}}>
                    <Text size="xl" weight="bold" className={classes.modalTitle}>
                        Создать новый проект
                    </Text>

                    <div className={classes.form} style={{display: 'flex', flexDirection: 'column', gap: '20px', }}>
                        <TextField
                            label="Название проекта"
                            value={projectName}
                            onChange={(value) => setProjectName(value || '')}
                            className={classes.formField}
                            required
                        />

                        <TextField
                            label="Описание"
                            value={projectDescription}
                            onChange={(value) => setProjectDescription(value || '')}
                            className={classes.formField}
                            rows={4}
                            type= 'textarea'
                        />

                        {/* <TextField
                            label="Номер проекта"
                            value={projectNumber}
                            onChange={(value) => setProjectNumber(value || '')}
                            className={classes.formField}
                            required
                        /> */}

                        <Combobox
                            label="Компания"
                            items={companyItems}
                            value={selectedCompany}
                            onChange={(value) => setSelectedCompany(value)}
                            getItemLabel={(item) => item.label}
                            getItemKey={(item) => item.id}
                            className={classes.formField}
                            placeholder="Выберите компанию"
                            required
                        />

                        <DatePicker
                            label="Дата начала"
                            value={projectStartDate}
                            onChange={setProjectStartDate}
                            className={classes.formField}
                            placeholder="Выберите дату начала"
                            required
                        />

                        <DatePicker
                            label="Дата окончания"
                            value={projectEndDate}
                            onChange={setProjectEndDate}
                            className={classes.dateFieldEnd}
                            placeholder="Выберите дату окончания"
                        />

                        <div className={classes.modalActions} style={{display: 'flex', flexDirection: 'row', gap: '20px', justifyContent: 'end', alignItems: 'center'}}>
                            <Button
                                label="Отмена"
                                view="clear"
                                onClick={() => setIsModalOpen(false)}
                                className={classes.cancelButton}
                            />
                            <Button
                                label={isCreating ? "Создание..." : "Создать проект"}
                                onClick={handleCreateProject}
                                disabled={isCreating || !projectName || !selectedCompany || !projectStartDate}
                                className={classes.createButton}
                            />
                        </div>
                    </div>
                </Card>
            </Modal>
        </div>
    )
}

export default ProjectsContent